import type { PurchaseIntent } from './intent';

export function checkoutCopy(intent: PurchaseIntent) {
  const eur = intent.currency === 'EUR';
  const monthlyPrice = eur
    ? intent.planId === 'expert'
      ? '14,40 €'
      : '9,50 €'
    : intent.planId === 'expert'
      ? '359 Kč'
      : '239 Kč';
  const trialPrice = eur ? '1 €' : '1 Kč';
  const renewal = 'Automatické obnovení lze vypnout v profilu.';
  if (
    intent.source === 'trial' &&
    intent.planId === 'expert' &&
    intent.billingCycle === 'MONTHLY'
  ) {
    return {
      title: 'Zahajte zkušební období',
      description: `Vyzkoušejte aplikaci Kadeřník+ na 14 dní za ${trialPrice}, poté ${monthlyPrice} měsíčně. ${renewal}`,
    };
  }
  const plan = intent.planId === 'expert' ? 'EXPERT' : 'PRO (Basic)';
  return {
    title: `Vybrali jste ${plan} ${intent.billingCycle === 'YEARLY' ? 'ročně' : 'měsíčně'}`,
    description:
      intent.billingCycle === 'YEARLY'
        ? `Platba předem ${eur ? '148 €' : '3 690 Kč'} za rok. ${renewal}`
        : `Platba ${monthlyPrice} nyní a následně každý měsíc. ${renewal}`,
  };
}
